/* import __COLOCATED_TEMPLATE__ from './externally-managed-card.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import templateOnlyComponent from '@ember/component/template-only';
import type ModelTrainingConsentOptOutRequest from 'embercom/models/model-training-consent-opt-out-request';

interface ExternallyManagedCardSignature {
  Args: {
    dataSharingOptOut: ModelTrainingConsentOptOutRequest | null | undefined;
  };
}

const ExternallyManagedCard = templateOnlyComponent<ExternallyManagedCardSignature>();

export default ExternallyManagedCard;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::SecurityModelsDataSharing::ExternallyManagedCard': typeof ExternallyManagedCard;
  }
}
